/**
 * High level router.
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { FC } from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { PrivateRoutes } from './PrivateRoutes'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { Logout, AuthPage, useAuth } from '../modules/auth'
import { App } from '../App'

import CustomerRoute from '../users-section/customerRoute'
import OptedInRoute from '../users-section/user-communication/optedInRoute'
import { PageByUUID } from '../users-section/customer/page'
import { ClientLogin } from '../modules/auth/components/ClientLogin'
import LeadGenerateFormNew from '../pages/lead-generator/lead-generateNew'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env

const AppRoutes: FC = () => {
  const { currentUser } = useAuth()
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          <Route path="/:slug/:UUID" element={<PageByUUID />} />

          <Route path="/customer/*" element={<CustomerRoute />} />
          <Route path="/opted-in/*" element={<OptedInRoute />} />
          <Route path='/lead/:comapny/:project_uuid' element={<LeadGenerateFormNew />} />
          {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/dashboard' />} />
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='auth/distributor/:project/*' element={<AuthPage />} />
              <Route path='auth/:company/admin' element={<ClientLogin />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export { AppRoutes }
